<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Editar Grupo
        </span>
      </h3>
    </div>
    <Form url="/produtos/update-grupo" :grupo="grupo" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import GrupoData from "./GrupoData";

export default {
  name: "app-grupo-update",
  data() {
    return {
      grupo: new GrupoData({}),
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getGrupo(id_grupo) {
      try {
        const { data } = await this.$http.post("/produtos/get-grupos", {
          id: id_grupo,
        });
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const codigo = this.$route.params.id;

        this.setLoading(true);

        const grupo = await this.getGrupo(codigo);

        this.setLoading(false);

        if (!grupo.id || grupo == null) {
          this.$router.push({ name: "gruposLista" });
          return this.$toast.error("Grupo não encontrado!");
        }

        this.grupo = new GrupoData(grupo);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
</script>
